import { useState, useEffect, FC } from 'react';
import { useParams } from 'react-router-dom';
import { getRequest } from '../utils/api';
import { Incident } from '../interfaces/incident';
import { System } from '../interfaces/system';

const IncidentDetails: FC = () => {
  const { id } = useParams<{ id: string }>();
  const [incident, setIncident] = useState<Incident | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!id) return;

    const fetchIncident = async () => {
      try {
        setError(null);
        setLoading(true);

        const data = await getRequest<Incident>(`/incidents/${id}`);
        setIncident(data);
      } catch (err: any) {
        console.error('Error fetching incident:', err);
        setError(err.message || 'Failed to fetch incident details.');
      } finally {
        setLoading(false);
      }
    };

    fetchIncident();
  }, [id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        {error}
      </div>
    );
  }

  if (!incident) {
    return <div>Incident not found.</div>;
  }

  return (
    <div>
      <h2>Incident Details</h2>
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">System: {incident.system.name}</h5>
          <p>
            <strong>ID:</strong> {incident.id}
            <br />
            <strong>Created At:</strong> {incident.created_at}
            <br />
            <strong>Updated At:</strong> {incident.updated_at}
            <br />
            <strong>Description:</strong> {incident.description}
            <br />
            <strong>Priority:</strong> {incident.priority}
            <br />
            <strong>Status:</strong> {incident.status}
            <br />
            <strong>Resolved At:</strong> {incident.resolved_at}
            <br />
            <strong>Root Cause:</strong> {incident.root_cause}
            <br />
            {/*<strong>Acknowledged At:</strong> {incident.acknowledged_at}*/}
            <br />
            <strong>System ID:</strong> {incident.system.id}
            <br />
            <strong>System Name:</strong> {incident.system.name}
            <br />
          </p>
        </div>
      </div>
    </div>
  );
};

export default IncidentDetails;
